import { render, staticRenderFns } from "./PermPlacementsActions.vue?vue&type=template&id=cef32942&"
import script from "./PermPlacementsActions.vue?vue&type=script&lang=js&"
export * from "./PermPlacementsActions.vue?vue&type=script&lang=js&"
import style0 from "./PermPlacementsActions.vue?vue&type=style&index=0&scopd=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports